import React from 'react';
import './styles/MyCarousel.css';
import Slider from 'react-slick';

const MyCarousel = ({images}) => {


    // const slides = [
    //     { image: './carousel/0.jpg', caption: 'Caption for image 1' },
    //     { image: './carousel/1.jpeg', caption: 'Caption for image 2' },
    //     { image: './carousel/2.jpeg', caption: 'Caption for image 2' },
    //     { image: './carousel/3.jpeg', caption: 'Caption for image 2' },
    //     { image: './carousel/4.jpg', caption: 'Caption for image 2' },
    //     { image: './carousel/5.jpg', caption: 'Caption for image 2' },
    //     { image: './carousel/6.jpg', caption: 'Caption for image 2' },
    //     { image: './carousel/7.jpg', caption: 'Caption for image 2' },
    //     { image: './carousel/8.jpg', caption: 'Caption for image 2' },
    //     { image: './carousel/9.jpg', caption: 'Caption for image 2' },
    //     { image: './carousel/10.jpeg', caption: 'Caption for image 2' },
    // ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,

    };

    return (
        <div className="carousel-container">
            <Slider {...settings} >
                {images.map((image, index) => (
                    <div className="carousel-image-wrapper" key={index}>
                        <img src={image} alt={`Slide ${index}`} className="carousel-image" />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default MyCarousel;